import { useConfig } from '@browsing/config';
import {
    EA_CAROUSEL_CAMPAIGNS_THRESHOLD,
    getEAOpenCampaignsForCarousel,
    getTabs,
} from '@client/redux/modules/mylounge';
import { getCookie } from '@pegasus/utils';
import { useSelector } from 'react-redux';

export const useIsEACarouselVariant = (): boolean => {
    const config = useConfig();
    const tabs = useSelector(getTabs);
    const hasPlusOffersTab = tabs.some(tab => tab.event === 'PLUS_OFFER_EVENT');
    const isEACarouselEnabled =
        config.isEnabled('cw_ea_open_campaign_carousel') ||
        getCookie('zl_cw_ea_campaign_carousel') === 'true';
    const earlyAccessCampaigns = useSelector(getEAOpenCampaignsForCarousel);

    return (
        hasPlusOffersTab &&
        isEACarouselEnabled &&
        earlyAccessCampaigns &&
        earlyAccessCampaigns.length >= EA_CAROUSEL_CAMPAIGNS_THRESHOLD
    );
};
